export const AUTHENTICATED = "AUTHENTICATED";
export const NOT_AUTHENTICATED = "NOT_AUTHENTICATED";
export const INSERT_TOKEN = "INSERT_TOKEN";
export const REMOVE_TOKEN = "REMOVE_TOKEN";
export const INSERT_USER = "INSERT_USER";
export const REMOVE_USER = "REMOVE_USER";
export const INSERT_ALERT = "INSERT_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const SET_CATEGORY = "SET_CATEGORY";
export const SET_HOME_META = "SET_HOME_META";
export const INSERT_USER_BOOKS = "INSERT_USER_BOOKS";
export const REMOVE_USER_BOOKS = "REMOVE_USER_BOOKS";

export const HELP_FILTER_HAS_SEARCH = "search";
export const HELP_FILTER_HAS_CATEGORY = "category";
export const HELP_FILTER_HAS_ACTIVE = "active";

export const GENDERS = [
  {
    value: "M",
    label: "Male",
  },
  {
    value: "F",
    label: "Female",
  },
  {
    value: "N",
    label: "No-information",
  },
  {
    value: "O",
    label: "Other",
  },
];

export const HELP_PAGINATION_ITEM_LIMIT = 9;
